var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.161 3.835H10.423c-.882 0-1.597.715-1.597 1.597v32.97c0 .882.715 1.597 1.597 1.597h24.738c.882 0 1.597-.715 1.597-1.597V5.432c0-.882-.715-1.597-1.597-1.597Z",
  fill: "#4F52C3"
})), /*#__PURE__*/React.createElement("mask", {
  id: "reports_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 0,
  width: 29,
  height: 37
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.291.002H5.553c-.882 0-1.597.715-1.597 1.597v32.97c0 .882.715 1.597 1.597 1.597H30.29c.882 0 1.597-.715 1.597-1.597V1.599c0-.882-.715-1.597-1.597-1.597Z",
  fill: "#1782E5"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#reports_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.291.002H5.553c-.882 0-1.597.715-1.597 1.597v32.97c0 .882.715 1.597 1.597 1.597H30.29c.882 0 1.597-.715 1.597-1.597V1.599c0-.882-.715-1.597-1.597-1.597Z",
  fill: "#1782E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.753 33.94c.32-1.054.962-2.052 1.936-2.563 1.365-.718 3.106-.367 4.471-1.09 1.282-.678 1.916-2.12 2.54-3.429.626-1.305 1.476-2.698 2.881-3.058 1.533-.39 3.162.615 4.699.232.982-.244 1.752-1.034 2.235-1.92.488-.886.735-1.88 1.03-2.847.571-1.876 1.398-3.784 2.962-4.974a5.666 5.666 0 0 1 3.446-1.137c.75.008 1.556.203 2.04.778.363.431.49 1.01.594 1.565.531 2.89.703 5.836.874 8.77.148 2.563.296 5.142.044 7.697-.127 1.297-.375 2.627-1.113 3.7-.767 1.118-1.984 1.833-3.21 2.412-2.51 1.185-5.201 1.924-7.892 2.615-3.617.93-7.381 1.78-11.05 1.085-1.58-.299-3.09-.878-4.59-1.457-.743-.287-1.522-.595-2.04-1.201-.6-.699-.436-1.418-.288-2.232.18-.986.14-1.98.435-2.95l-.004.004Z",
  fill: "#FF8257"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.367 8.53H18.87M8.367 13.046h11.098M8.543 17.444h4.886",
  stroke: "#A5F9E8",
  strokeWidth: 1.996,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.66 9.348a3.202 3.202 0 1 0 0-6.404 3.202 3.202 0 0 0 0 6.404Z",
  fill: "#4F52C3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.46 19.244a2.435 2.435 0 1 0 0-4.87 2.435 2.435 0 0 0 0 4.87Z",
  fill: "#FF8257"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.914 28.839a2.81 2.81 0 1 0 0-5.621 2.81 2.81 0 0 0 0 5.62Z",
  fill: "#A5F9E8"
})));
export default SvgReports;